import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Surface, useTheme } from 'react-native-paper';
import { TreeNode } from '../TreeView';
import type { AssetNode, ProjectData } from "../../types/project"
// interface DrawingsTabProps {
//     selectedNode?: AssetNode | null
//     projectData?: ProjectData | null
// }
import type { TabComponentProps } from "../../types/tabs"

export const DrawingsTab: React.FC<TabComponentProps> = ({ selectedNode, projectData }) => {
    const theme = useTheme();

    if (!selectedNode) {
        return (
            <Surface style={[styles.container, { backgroundColor: theme.colors.elevation.level1 }]}>
                <Text style={{ color: theme.colors.onSurface }}>Please select a node to view drawings</Text>
            </Surface>
        );
    }

    return (
        <Surface style={[styles.container, { backgroundColor: theme.colors.elevation.level1 }]}>
            <Text style={{ color: theme.colors.onSurface }}>
                Drawings for node: {selectedNode.name}
            </Text>
            {/* Add your drawings-specific content here */}
        </Surface>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
    }
});
